import logoImg from '~/assets/icons/logo-full.svg';
import Button from '~/components/new/Button';
import { RemixIconNames } from '~/components/ui/Icon';
import { isStaging } from '~/utils/env';
import { classNames } from '~/utils/styles';

export default function SmallTopBar({ onOpen }: { onOpen: () => void }) {
    return (
        <div
            className={classNames({
                'topbar-small-wrapper topbar-small small-or-medium-only': true,
                'topbar-small-staging': isStaging(),
            })}>
            <div className='topbar-small'>
                <h1 className='topbar-brand'>
                    <img
                        src={logoImg}
                        alt='Remotely'
                    />
                </h1>

                <Button
                    icon={RemixIconNames.RiMenuLine}
                    onClick={onOpen}
                    variant='floating'
                    size='medium'
                    title='Menu'
                />
            </div>
        </div>
    );
}
